/**
 * Table Plugins
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'tables';
const log = debug(MODULE_NAME);

// Fonts
import * as tableCellIcons from './table-cell-icons';
import * as responsiveTables from './responsive-tables';
import tableSideScroller from "./table-side-scroller";

// Export
export function exec () {
	log('Running...');
	tableCellIcons.exec();
	responsiveTables.exec();
	tableSideScroller();
}

export {exec as default, tableCellIcons};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/tables/index.js